export const normalizePdfUrl = (url: string): string => url.replace(/^http:/i, 'https:');

export const getPdfPageNumbers = (numPages: number): number[] =>
  Array.from({ length: Math.max(0, numPages) }, (_, index) => index + 1);
